import VueRouter from 'vue-router';
import * as Sentry from '@sentry/vue';

export const setupVueRouter = () => {
  const { isNavigationFailure, NavigationFailureType } = VueRouter;
  const originalPush = VueRouter.prototype.push;
  VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).then(() => true).catch((err) => {
      if (!isNavigationFailure(err, NavigationFailureType.redirected) && !isNavigationFailure(err, NavigationFailureType.aborted)) {
        Sentry.captureException(err);
      }
      return false;
    });
  };
};
